import { render, staticRenderFns } from "./VoluntarioPublico.vue?vue&type=template&id=61498156&scoped=true"
import script from "./VoluntarioPublico.vue?vue&type=script&lang=js"
export * from "./VoluntarioPublico.vue?vue&type=script&lang=js"
import style0 from "./VoluntarioPublico.vue?vue&type=style&index=0&id=61498156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61498156",
  null
  
)

export default component.exports